import React, {useEffect, useState} from "react";
import SimmsTextArea from "../../../../../../components/input/SimmsTextArea";
import {updateDiligenceAssetMessage} from "../../../../../../api/asset/DiligenceService";
import {handleActiveError, handleActiveToast} from "../../../../../../components/sonner/ToastBasic";
import "./diligenceAssetMessageModal.css";

function DiligenceAssetMessageModal({
    open,
    onClose,
    diligenceId,
    asset,
    rowIndex,
    message,
    setUpdateData,
    readOnly,
}) {
    const [draft, setDraft] = useState(message ?? "");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        setDraft(message ?? "");
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const onKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose?.();
            }
        };
        window.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [open, onClose, message]);

    if (!open || !asset) {
        return null;
    }

    const handleSave = async () => {
        if (readOnly || saving) {
            return;
        }

        if (draft === message) {
            onClose?.();
            return;
        }

        if (draft === "") {
            handleActiveError({message: "저장 실패", description: "내용을 입력해주세요."});
            return;
        }

        setSaving(true);
        try {
            const response = await updateDiligenceAssetMessage(diligenceId, asset.id, draft);
            if (response.status === 200) {
                handleActiveToast({message: "저장 되었습니다."});
                setUpdateData((prev) => {
                    const next = [...prev];
                    next[rowIndex] = draft;
                    return next;
                });
                onClose?.();
            } else if (response.status === 201 || response.status === 202) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else {
                handleActiveError({message: "처리실패", description: "알 수 없는 원인"});
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="diligence-message-modal-root">
            <div className="diligence-message-modal-overlay" onClick={onClose} aria-hidden />
            <div
                className="diligence-message-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="diligence-message-modal-title"
            >
                <div className="diligence-message-modal__header">
                    <div>
                        <h3 id="diligence-message-modal-title" className="diligence-message-modal__title">
                            실사내용
                        </h3>
                        <p className="diligence-message-modal__meta">{asset.assetName}</p>
                    </div>
                    <button
                        type="button"
                        className="diligence-message-modal__close"
                        onClick={onClose}
                        aria-label="닫기"
                    >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                                d="M18 6L6 18M6 6l12 12"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                </div>

                <div className="diligence-message-modal__body">
                    <label className="diligence-message-modal__label">내용</label>
                    <SimmsTextArea
                        auth={!readOnly}
                        data={draft}
                        update={readOnly}
                        style={{width: "100%", minHeight: "140px", margin: 0}}
                        onChange={setDraft}
                    />
                </div>

                {!readOnly ? (
                    <div className="diligence-message-modal__footer">
                        <button
                            type="button"
                            className="diligence-message-modal__btn is-primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? "저장 중…" : "저장"}
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default DiligenceAssetMessageModal;
